export default function DeliveryAndShipping() {
  return (
    <div className="sm:mt-36 p-5 mt-16 mb-16 flex flex-col gap-10">
      <h1 className="font-montserrat font-medium text-xl sm:text-2xl capitalize">
        Delivery And Shipping
      </h1>
      <p>Domestic Shipping Policy</p>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Processing Period</h3>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - Please allow 1-2 business days to process the
            order.
          </li>
          <li className="sm:text-md text-sm">
            - If there will be a significant delay in
            shipment of your order, we will contact you via
            email or WhatsApp.
          </li>
        </ul>
      </div>
      {/* <div className="flex flex-col gap-5">
        <h3 className="font-bold">Shipping Rates</h3>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - We currently only deliver in Lebanon.
          </li>
          <li className="sm:text-md text-sm">
            - 3$/order for domestic shipping.
          </li>
          <li className="sm:text-md text-sm">
            - Free delivery on orders above 50$.
          </li>
        </ul>
      </div> */}
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">
          Shipment Confirmation And Order Tracking
        </h3>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - You will receive a shipment confirmation email
            within 24hours from placing your order.
          </li>
          <li className="sm:text-md text-sm">
            - You will also receive a tracking Number to be
            able to check the status of your order.
          </li>
        </ul>
      </div>
    </div>
  );
}
